import { Breadcrumbs } from "../components/global/Breadcrumbs"
import { ContactInfo } from "../components/contact/ContactInfo"
import { ContactForm } from "../components/contact/ContactForm"
import { useState } from "react"
import { MessageResultBox } from "../components/contact/MessageResultBox"
import "./contact.css"

export function Contact(){
    const [messageSuccess, setMessageSuccess] = useState(null)

    return (
        <div className="contact-page mx-auto">

            {
                messageSuccess !== null ?
                    <MessageResultBox
                        messageSuccess={messageSuccess}
                        setMessageSuccess={setMessageSuccess}
                    />
                    :
                    null
            }

            <Breadcrumbs dynamicPath="Contact" />

            <div className="d-flex justify-content-between contact-wrapper lg-row">

                <ContactInfo />
                <ContactForm setMessageSuccess={setMessageSuccess} />

            </div>

        </div>
    )
}